import React from "react";
import { tokenFor } from "../../lib/session";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ Children: ReactComponent, isAdminRoute }) => {
  const token = tokenFor("customer");
  const user = localStorage.getItem("user") || "";
  const agent_token = tokenFor("agent");
  const agent_user = localStorage.getItem("agent_user");
  if (isAdminRoute == true) {
    return agent_token && agent_user ? (
      <ReactComponent authUser={true} />
    ) : (
      <Navigate to="/" />
    );
  } else {
    return token && user ? (
      <ReactComponent authUser={true} />
    ) : (
      <Navigate to="/" />
    );
  }
};
export default PrivateRoute;
